import api from 'data/api';

export const loadPresets = api('GET /api/user/presets');
